import React from "react";
import Markdown from "markdown-to-jsx";

const CustomLink = ({ children, ...props }) => (
	<a
		{...props}
		target="_blank"
		rel="noopener noreferrer"
		className={["text-primary underline", props.className].filter(Boolean).join(" ")}
	>
		{children}
	</a>
);

// O Markdown junta as linhas de um mesmo parágrafo num espaço só: o Enter
// simples digitado no aviso desaparece. Aqui cada Enter simples vira uma
// quebra de linha de verdade (os dois espaços no fim da linha são a regra
// "hard break" do Markdown, que sai como <br/> no HTML). O Enter duplo fica
// intacto, continuando a separar parágrafos.
const normalizarTexto = (texto) =>
        String(texto == null ? "" : texto).replace(/\r\n?/g, "\n");

const comQuebrasDoTexto = (texto) =>
        normalizarTexto(texto)
		.replace(/([^\n])\n(?!\n)/g, "$1  \n");

const dividirEmBlocos = (texto) =>
        normalizarTexto(texto)
                .split(/\n{2,}/)
                .filter((bloco) => /\S/.test(bloco));

const AnnouncementsMarkdown = ({ children }) => {
	const options = React.useMemo(() => {
		const allowedBlock = [
			"p", "br", "strong", "b", "em", "i", "u", "s", "del",
			"ul", "ol", "li",
			"h1", "h2", "h3", "h4", "h5", "h6",
			"blockquote", "hr",
			"code", "pre",
			"a", "img"
		];

		const overrides = {
			p: { props: { className: "m-0" } },
			ul: { props: { className: "m-0 list-disc pl-5" } },
			ol: { props: { className: "m-0 list-decimal pl-5" } },
			blockquote: { props: { className: "m-0 border-l-4 pl-3 italic" } },
			pre: { props: { className: "m-0 whitespace-pre-wrap break-words" } },
			a: { component: CustomLink },
			img: {
				component: (props) => (
					<a
						href={props.src}
						target="_blank"
						rel="noopener noreferrer"
						className="inline-block max-w-full"
					>
						<img {...props} alt={props.alt || ""} className="max-w-full rounded-md border object-contain" style={{ maxHeight: 220 }} />
					</a>
				)
			},
		};

		const allTags = [
			"a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big",
			"blockquote","body","br","button","canvas","caption","cite","code","col","colgroup",
			"data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed",
			"fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head",
			"header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label",
			"legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter",
			"nav","noscript","object","ol","optgroup","option","output","p","param","picture",
			"pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small",
			"source","span","strong","style","sub","summary","sup","table","tbody","td","textarea",
			"tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"
		];

		allTags.forEach((tag) => {
			if (!allowedBlock.includes(tag) && !(tag in overrides)) {
				overrides[tag] = (el) => el.children || null;
			}
		});

		return {
			disableParsingRawHTML: true,
			forceBlock: true,
			overrides,
		};
	}, []);

	if (!children && children !== 0 && children !== "") return null;

        if (typeof children !== "string") {
                return <Markdown options={options}>{children}</Markdown>;
        }

        const blocos = dividirEmBlocos(children);
        if (!blocos.length) return null;

        return (
                <div className="max-w-none break-words text-sm leading-relaxed space-y-5">
                        {blocos.map((bloco, index) => (
                                <div key={index}>
                                        <Markdown options={options}>{comQuebrasDoTexto(bloco)}</Markdown>
                                </div>
                        ))}
                </div>
        );
};

export default AnnouncementsMarkdown;
